if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');

      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
      });

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
